import React from 'react';

const Family = () => {
  return (
    <div className='container scrollable-content'>
      <h3>Working with Words</h3>
      <p className='question'>A. Find the words from the text and solve the puzzle. Clues are given below.</p>

      <div>
        <h4>ACROSS</h4>
        <p>1. The custom of having more than one wife at the same time.</p>
        <h4>POLYGAMY</h4>
        <p>5. To find an acceptable way of dealing with opposing ideas, needs etc.</p>
        <h4>RECONCILE</h4>
        <p>6. The process in which towns, streets, etc. are built where there was once countryside.</p>
        <h4>URBANIZATION</h4>
        <p>7. The process by which somebody learns to behave in an acceptable way in their society.</p>
        <h4>SOCIALIZATION</h4>
      </div>

      <div>
        <h4>DOWN</h4>
        <p>1. Ruled or controlled by men.</p>
        <h4>PATRIARCHAL</h4>
        <p>2. The act of taking over a position.</p>
        <h4>SUCCESSION</h4>
        <p>3. Done in a way without caring if people are shocked.</p>
        <h4>BLATANT</h4>
        <p>4. Single-parent.</p>
        <h4>LONEPARENT</h4>
      </div>

      <hr/>

      <div>
        <p className='question'>B. Find the meanings of the following family-related words and use them in your own sentences.</p>
       <br/>
        <p className='question'>Nuclear Family</p>
        <p><strong>Meaning:</strong> A nuclear family is a small family that has just a mother, a father, and their children living together in one house.</p>
        <p><strong>Sentence:</strong> My uncle has a small nuclear family with just him, his wife, and their two kids.</p>
<br/>
        <p className='question'>Monogamy</p>
        <p><strong>Meaning:</strong> Monogamy means having only one husband or wife at a time.</p>
        <p><strong>Sentence:</strong> Society will be happier if people practice monogamous marriage.</p>
        <br/>
        <p className='question'>Sibling-in-law</p>
        <p><strong>Meaning:</strong> The brother or sister of your spouse, or the spouse of your brother or sister.</p>
        <p><strong>Sentence:</strong> My sister's husband is my brother-in-law.</p>
<br/>
        <p className='question'>Milk Kinship</p>
        <p><strong>Meaning:</strong> A cultural or social relationship formed between people who were breastfed by the same woman.</p>
        <p><strong>Sentence:</strong> In some cultures, people who have milk kinship cannot marry each other because they are seen as family.</p>
<br/>
        <p className='question'>Matrilineal</p>
        <p><strong>Meaning:</strong> A family system where a child follows the mother's side of the family.</p>
        <p><strong>Sentence:</strong> In a matrilineal society, property and family names are passed down through the mother's side.</p>
<br/>
        <p className='question'>Nepotism</p>
        <p><strong>Meaning:</strong> Giving jobs or favors to your family members or friends, especially when they are not the most qualified.</p>
        <p><strong>Sentence:</strong> The manager showed nepotism by hiring his brother instead of a more experienced candidate.</p>
<br/>
        <p className='question'>Maternity</p>
        <p><strong>Meaning:</strong> Everything related to pregnancy and having a baby.</p>
        <p><strong>Sentence:</strong> She took maternity leave to care for her newborn baby.</p>
      </div>
<hr/>
      <div>
        <p className='question'>C. Prefix activity: Make at least five words using these prefixes.</p>
        <p><strong>pre-:</strong> prefix, preview, prepare, prevent, preheat</p>
        <p><strong>semi-:</strong> semicircle, semifinal, semiconductor, semiannual, semiautomatic</p>
        <p><strong>sub-:</strong> submarine, subway, subordinate, subtitle, subconscious</p>
        <p><strong>mis-:</strong> misunderstand, mislead, misbehave, mistake, misinformation</p>
        <p><strong>mono-:</strong> monopoly, monotone, monochrome, monologue, monarchy</p>
        <p><strong>un-:</strong> unhappy, unkind, unpack, untie, unlock</p>
        <p><strong>in-:</strong> incorrect, invisible, inactive, inefficient, inhuman</p>
        <p><strong>inter-:</strong> intersection, international, internet, interview, interact</p>
      </div>

      <hr />

      <div>
        <h3>Comprehension</h3>
        <p className='question'>A. The heading of the first five paragraphs of the above text:</p>
        <p>a. Patriarchal family (3rd paragraph)</p>
        <p>b. Functions of the family (2nd paragraph)</p>
        <p>c. Modern model of family (5th paragraph)</p>
        <p>d. Effects of industrialization on family structure (4th paragraph)</p>
        <p>e. Defining family(1st paragraph)</p>
      </div>
<hr/>
      <div>
        <p className='question'>B. Answer the following questions.</p>
        <p className='question'>a. What type of family is thought to be the oldest form of the family?</p>
        <p>= An extended family includes not only parents and their unmarried children but also other relatives like uncles, aunts, cousins, grandparents, and dependents living together or closely connected. This type of family structure is considered the oldest form of family organization in human history.</p>
        <p className='question'>b. How does a family provide security to its members?</p>
        <p>= A family provides security to its members by offering both mental and physical support. It protects its members from external pressures and gives them the confidence to face life's challenges. Family security includes emotional and psychological support through warmth, love, and companionship. Additionally, families provide physical security, especially for those who are too young or too old, ensuring their safety and well-being. Families also guide members by establishing rules and norms for behavior, which helps maintain a stable and secure environment.</p>
        <p className='question'>c. What were the features of medieval European family?</p>
        <p>= The features of the medieval European family were as follows:
</p><p>
1. It was a male-dominated or patriarchal family, where the male head of the household held authority over the family members.
</p><p>
2. It was typically an extended family, often including several generations living together. In some cases, the male heads of clans were allowed to have multiple wives and concubines.</p>
        <p className='question'>d. What caused the dissolution of extended families in the West?</p>
        <p>= Industrialization, urbanization, and migration of young people to cities for work caused the breakup of extended families in the West.</p>
        <p className='question'>e. What change occurred in gender role in the modern family that emerged after the Industrial Revolution?</p>
        <p>= After the Industrial Revolution, gender roles in the modern family changed. Patriarchal rule gave way to more equality between men and women. Men worked outside, while women cared for children, but many responsibilities became shared. Rising divorce rates and changing family structures also led to more one-parent households.</p>
        <p className='question'>f. What is family law?</p>
        <p>=Family law is the area of law that deals with legal issues related to family relationships and domestic matters. It covers marriage, divorce, child custody, adoption, property inheritance, and other family-related matters. Family law balances the rights of individuals with the interests of society and varies across cultures.</p>
        <p className='question'>g. How is modern marriage defined?</p>
        <p>= Modern marriage is defined as a voluntary social and legal union, usually between a man and a woman, that unites their lives legally, emotionally, and economically. It involves mutual consent and often reflects equality in rights and responsibilities between partners.</p>
        <p className='question'>h. What do special family courts try to do?</p>
        <p>= Special family courts aim to deal more fairly with sensitive family issues such as divorce, child custody, and marital disputes. They focus on balancing private and public interests while promoting justice and reconciliation whenever possible.</p>
        <p className='question'>i. What does the legislation on child labour and child abuse declare?</p>
        <p>= The legislation on child labour and child abuse declares that society holds responsibility for ensuring a child's best interests. It includes provisions like compulsory education and protection from exploitation, even overriding parental authority when necessary.</p>
        <p className='question'>j. What is common among most legal systems regarding property?</p>
        <p>= In most legal systems, there are provisions for dealing with property left by a deceased family member. Surviving spouses or children often have the right to claim or contest the inheritance, even in the absence of a will.</p>
      </div>

      <hr />

      <h3>Critical Thinking</h3>
      <div>
        <p className='question'>a. What changes have started to occur in Nepali families in recent days? What impacts will they bring on the society? Discuss.</p>
        <p>=In recent years, Nepali families have shifted from extended to nuclear setups due to urbanization, migration, and changing lifestyles. Young people are moving to cities for better opportunities, leaving elderly family members in rural areas. Gender roles are also changing, with both men and women sharing responsibilities.
</p><p>
Impacts on Society:</p><p>
Positive Effects:</p><p>

1. Increased equality between men and women
</p><p>
2. More freedom in personal choices
</p><p>
3. Better access to education and jobs
</p><p>
Negative Effects:
</p><p>
1. Isolation and neglect of elderly people
</p><p>
2. Weaker family bonds and rising divorce rates
</p><p>
3. Overcrowded cities and underdeveloped villages
</p><p>
In conclusion, while modern family trends bring progress, they also challenge traditional values and social harmony in Nepal.

        </p>
        <hr/>
        <p className='question'>b. We see many elderly people living in old age homes in Nepal these days. Some of them are abandoned while others live there willingly. Do you think Nepali people are deviating from their traditional culture? Give reasons.</p>
        <p>=Yes, I believe Nepali people are deviating from their traditional culture. In the past, elders were highly respected, cared for within joint families, and regarded as sources of wisdom. However, this traditional value system is weakening in today's society.
</p><p>
Many elderly people now live in old age homes—some by choice, but many because they have been abandoned. Modern lifestyles, influenced by urbanization and Western culture, have led to the rise of nuclear families. This shift has made people more self-centered and less committed to caring for their aging parents.
</p><p>
Elderly people, especially in rural areas, often face emotional neglect, loneliness, and even poverty. Children now prioritize personal freedom, careers, and material success over family responsibilities. The growing generation gap and lack of communication have worsened the situation.
</p><p>
If this trend continues, the traditional values of love, respect, and care for elders may fade completely. There is a serious need for both emotional awareness and institutional support to care for the elderly in Nepal.</p>
      </div>

      <hr />

      <h3>Writing</h3>
      <div>
        <p className='question'>A. Write an essay on <strong>The Importance of Family</strong>. Use these guiding questions:</p>
        <p>- Why is family important to you?</p>
        <p>- Why is family important for society?</p>
        <p>- How do you think families will change in the future?</p>
        <p>=The Importance of Family
Family is one of the most important aspects of human life. It refers to a group of people connected by blood, marriage, law, or love, who live together or share strong emotional bonds. For most people, family means love, care, support, and belonging. It plays a vital role in shaping a person's life and values.
</p><p>
To me, family is everything. My family is my source of strength, comfort, and happiness. I feel secure knowing that I have people who care for me and support me no matter what. I have learned the values of love, respect, patience, and responsibility from my family. They are always there during good and bad times. This emotional support gives me the confidence to face the world. My family makes me feel proud and grateful every single day.
</p><p>
Family is also important for society. A good family creates good individuals, and good individuals build a better society. Families teach us social values like kindness, honesty, and cooperation. They help us understand our roles in society and guide us to become responsible citizens. Without strong families, society would lack unity, discipline, and emotional well-being.
</p><p>
In the future, families may continue to change. Due to modernization and technological advancements, joint families are becoming rare, and nuclear families are becoming more common. While this gives more freedom, it also brings challenges like loneliness, lack of care for elders, and weak family bonds. However, no matter how family structures change, the emotional value of family will always remain important.
</p><p>
In conclusion, family is the foundation of life—personally and socially. It teaches us how to love, live, and grow. We should always cherish our families and do our part to strengthen these precious relationships.

</p>
        <hr />
        <p className='question'>B. Some people think it is better to live in a nuclear family, while others think living in an extended family is more advantageous. What do you think? Write an essay discussing the advantages and disadvantages of both.</p>
        <p>= Family is very important because it provides love, care, and support. People live in two main types of families today: nuclear and extended. Both have their own advantages and disadvantages.
</p><p>
A nuclear family consists of parents and their children. It offers privacy, easier decision-making, and fewer chances of conflict because of fewer members. Family members can focus more on their needs, and financial responsibilities may be easier to manage. However, nuclear families can sometimes feel lonely, and there may be less care and support for elderly members. Children might miss the guidance of a larger family.
</p><p>
An extended family includes many generations living together, such as grandparents, uncles, aunts, and cousins. This creates strong emotional bonds and offers good support in times of need. Childcare and elder care are shared among family members. It also helps preserve culture, traditions, and values. On the downside, extended families may lack privacy, face more disagreements, and have financial pressure due to many members. Sometimes individual freedom is limited.
</p><p>
In my opinion, both types of families are important and useful in their own ways. What matters most is the love, respect, and understanding shared among family members.</p>
      </div>

      <hr />

      <h3>Grammar</h3>
      <div>
        <p className='question'>B. Choose the best answer to complete the sentences.</p>
        <p>a. "How much was your parking ticket?" "Fifty rupees." "Oh well, it <strong>could have</strong> been worse."</p>
        <p>b. It <strong>might have</strong> got lost in the post. These things happen sometimes.</p>
        <p>c. "Sorry I'm late. I got delayed at work." "You <strong>could have</strong> called. I was really worried about you."</p>
        <p>d. "I don't think he meant to be rude." "He <strong>must have</strong> said sorry."</p>
        <p>e. "Whose signature is this?" "I don't know. It <strong>could</strong> be Manoj's. That looks a bit like an M."</p>
        <p>f. I had it when I left the office, so I <strong>must have</strong> lost it on the way home.</p>
        <p>g. You <strong>might</strong> think it's funny, but I think it's pathetic.</p>
      </div>
<hr/>
      <div>
        <p className='question'>C. Complete the following sentences using correct modal verbs:</p>
        <p>a. At the end of the course, <strong>students must submit their assignments.</strong></p>
        <p>b. If you want to earn a lot of money, <strong>you should work hard on smarter things.</strong></p>
        <p>c. You were not in your house yesterday. You <strong>might have been at your friend's house.</strong></p>
        <p>d. I'm quite busy tomorrow. I <strong>might not join you.</strong></p>
        <p>e. When you were a small kid, <strong>you might have been notorious.</strong></p>
        <p>f. My car is broken. I <strong>might buy a new one.</strong></p>
        <p>g. I've got a fast internet connection at home. I <strong>should not misuse it.</strong></p>
        <p>h. Even though she didn't study well, she <strong>might have passed the exam.</strong></p>
        <p>i. There are plenty of newspapers in the library. You <strong>can pick one if you want.</strong></p>
        <p>j. What were you thinking playing on the road? You <strong>could have been hurt in an accident.</strong></p>
        <p>k. I have no time. I <strong>must not waste any more of it.</strong></p>
        <p>l. You don't look well. You <strong>might be delirious.</strong></p>
      </div>
    </div>
  );
};

export default Family;



